<form [formGroup]="periodeFormGroup">

  <div fxLayoutGap="10px">

    <div fxLayoutAlign="center">
      <mat-grid-list cols="2" rowHeight="80px" fxFlex="70" fxLayoutAlign="center">
        <mat-grid-tile>
          <mat-list-item>
            <h3 mat-line style="color: rgba(0, 0, 0, 0.54)"><mat-icon mat-list-icon style="color: rgba(0, 0, 0, 0.54); fill: rgba(0, 0, 0, 0.54)">euro_symbol</mat-icon> Coût estimé initial</h3>
            <mat-label mat-line fxLayoutAlign="end" style="color: rgba(0, 0, 0, 0.54)" matTooltip="{{getInitData()}}"><strong>{{cout_estime | currency:'EUR':'symbol':'1.0-0' }}</strong></mat-label>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-list-item>
            <h3 mat-line><mat-icon mat-list-icon>euro_symbol</mat-icon> Coût calculé</h3>
            <mat-label mat-line fxLayoutAlign="end"><strong>{{cout | currency:'EUR':'symbol':'1.0-0' }}</strong></mat-label>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-grid-tile>
      </mat-grid-list>

    </div>

      <div fxLayout="column"
           fxLayoutGap="10px"
           fxLayoutAlign="center"
           style="padding-top: 10px;">
        <div fxLayoutAlign="center" fxLayoutGap="10px">
          <mat-form-field fxFlex="15" fxFlex.lt-md="30" fxFlex.xs="35">
            <input matInput formControlName="date_debut_validee"
                   (dateChange)="onDateSelected($event, 'debut')"
                   [matDatepickerFilter]="dateSvc.filterWE"
                   [matDatepicker]="date_debut" placeholder="* Du :">
            <mat-datepicker-toggle matSuffix [for]="date_debut"></mat-datepicker-toggle>
            <mat-datepicker #date_debut></mat-datepicker>
          </mat-form-field>

          <mat-form-field fxFlex="15" fxFlex.lt-md="30" fxFlex.xs="35">
            <input matInput formControlName="date_fin_validee"
                   [min]="minDate"
                   (dateChange)="onDateSelected($event)"
                   [matDatepickerFilter]="dateSvc.filterWE"
                   [matDatepicker]="date_fin" placeholder="* Au :">
            <mat-datepicker-toggle matSuffix [for]="date_fin"></mat-datepicker-toggle>
            <mat-datepicker #date_fin></mat-datepicker>
          </mat-form-field>

          <mat-form-field fxFlex="15" fxFlex.lt-md="10" fxFlex.xs="15"
                          fxFlexAlign="center">
            <input matInput formControlName="duree_validee" type="number" style="text-align: center"
                   matTooltip="Durée totale du recrutement en jours"
                   placeholder="Durée totale du recrutement en jours">
          </mat-form-field>
        </div>

        <!-- sur quotité (indiciaire) -->

        <div fxLayoutAlign="center" fxLayoutGap="10px"
             *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
          <mat-form-field fxFlex="12" fxFlex.lt-sm="30">
            <input formControlName="quotite_validee"
                   matInput
                   type="number"
                   matTooltip="% Quotité à ajuster"
                   placeholder="* % Quotité à ajuster">
            <div class="invalid-field" *ngIf="periodeFormGroup.get('quotite_validee').touched">
              <div *ngIf="periodeFormGroup.get('quotite_validee').value <= 0">
                doit être supérieur à 0
              </div>
              <div *ngIf="periodeFormGroup.get('quotite_validee').value > 100">
                doit être inférieur ou égal à 100
              </div>
            </div>
          </mat-form-field>

          <mat-form-field fxFlex="15" fxFlex.lt-md="10" fxFlex.xs="15"
                          fxFlexAlign="center">
            <input matInput formControlName="etp" type="number" style="text-align: center"
                   matTooltip="ETP"
                   placeholder="ETP">
          </mat-form-field>
        </div>

        <!-- sur vacation horaires, forfait (horaire) -->

        <div fxLayoutAlign="center"  *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
          <mat-form-field fxFlex="12" fxFlex.lt-sm="30">
            <input formControlName="vacation_horaires_validee"
                   matInput
                   type="number"
                   matTooltip="* Horaires à ajuster"
                   placeholder="* Horaires à ajuster">
            <div class="invalid-field" *ngIf="periodeFormGroup.get('vacation_horaires_validee').touched">
              <div *ngIf="periodeFormGroup.get('vacation_horaires_validee').value <= 0">
                doit être supérieur à 0
              </div>
            </div>
          </mat-form-field>
        </div>

    </div>

  </div>
</form>
